module.exports = __webpack_public_path__ + "static/media/label-1.5dc40660.svg";